import { createReducer, on } from '@ngrx/store';
import { OsUpdatesApiActions } from './allowed-os-updates.actions';
import { adapter, initialState } from './allowed-os-updates.state';

export const allowedOsUpdateFeatureKey = 'allowedOsUpdates';

export const AllowedOsUpdatesReducer = createReducer(
  initialState,
  on(OsUpdatesApiActions.deviceAllowedUpdatesLoaded, (state, { updates }) => adapter.upsertMany(updates, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAllowedOsUpdateIds = selectIds;

export const selectAllowedOsUpdateEntities = selectEntities;

export const selectAllAllowedOsUpdates = selectAll;
